import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=5bbda180&"
var script = {}
import style0 from "./Heading.vue?vue&type=style&index=0&id=5bbda180&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports